export enum StratalotOccupationStatutEnum {
  congé = 'congé',
  libre = 'libre',
  occupé = 'occupé',
  vendu = 'vendu',
  bloqué = 'bloqué',
  horsVente = 'hors vente'
}
